import { pressMockupData } from "@/pages/analysis/idleTime";
import styled from "@emotion/styled";
import ApexCharts from "react-apexcharts";

interface PressWorkTimeDualChartProps {
  machine: number;
}

export const PressWorkTimeDualChart = ({ machine }: PressWorkTimeDualChartProps) => {
  const pressData = pressMockupData[machine];

  if (!pressData) return <div>해당 기계 데이터 없음</div>;

  const timeStringToMinutes = (time: string): number => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };

  const categories = pressData.map((data) => data.pressName);

  // 가동 / 비가동 시리즈
  const workSeries = [
    {
      name: "가동",
      data: pressData.map((data) => timeStringToMinutes(data.workTime)),
    },
    {
      name: "비가동",
      data: pressData.map((data) => timeStringToMinutes(data.idleTime)),
    },
  ];

  // 대기 / 금형교체 / 에러 시리즈
  const downtimeSeries = [
    {
      name: "대기",
      data: pressData.map((data) => timeStringToMinutes(data.waitTime)),
    },
    {
      name: "금형교체",
      data: pressData.map((data) => timeStringToMinutes(data.moldChangeTime)),
    },
    {
      name: "에러",
      data: pressData.map((data) => timeStringToMinutes(data.errorTime)),
    },
  ];

  const baseOptions = (title: string) => ({
    chart: {
      type: "bar" as const,
      stacked: true,
      height: 500,
    },
    plotOptions: {
      bar: {
        horizontal: true,
        barHeight: "70%",
      },
    },
    xaxis: {
      categories,
      title: { text: "시간 (분)" },
    },
    tooltip: {
      y: {
        formatter: (val: number) => `${val} 분`,
      },
    },
    legend: {
      position: "top" as const,
    },
    title: {
      text: title,
      align: "center" as const,
    },
  });

  return (
    <Wrapper>
      <ChartBlock>
        <ApexCharts
          options={baseOptions("가동/비가동 시간")}
          series={workSeries}
          type="bar"
          height={170}
        />
      </ChartBlock>
      <ChartBlock>
        <ApexCharts
          options={baseOptions("대기/금형교체/에러 시간")}
          series={downtimeSeries}
          type="bar"
          height={170}
        />
      </ChartBlock>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  gap: 32px;
  padding: 24px;
`;

const ChartBlock = styled.div`
  flex: 1;
`;

const ChartTitle = styled.h3`
  margin-bottom: 16px;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
`;
